import React, { useContext, useState, useEffect } from "react";
import { Navigate, useLocation, Route, Routes } from "react-router-dom";

import { decodeToken, decodeTokenWithParam } from "../../../shared/helpers";
import { demoContext } from "../../../shared/store/contexts";

import { SetupLayout } from "../../organisms/Layouts"; // Import SetupLayout here
import ClaimOrganizationPage from "../ClaimOrganization";
import ClaimSpecificOrganizationPage from "../ClaimSpecificOrganization";
import CreateOrganizationPage from "../CreateOrganization";
import EditOrganizationPage from "../EditOrganization";
import JoinOrganizationPage from "../JoinOrganization";
import OrganizationDashboardHome from "../OrganizationDashboard/Home";
import SearchOrganizationPage from "../SearchOrganizationResult";

const DashboardHome = () => {
  const location = useLocation();
  const { token } = useContext(demoContext);
  const [isValid, setIsValid] = useState(true);

  // useEffect(() => {
  //   if (token) {
  //     setIsValid(decodeTokenWithParam(token));
  //   } else {
  //     setIsValid(decodeToken());
  //   }
  // }, [token]);

  return (
    <>
      {/* {!isValid && <Navigate to="/login" state={{ returnTo: location.pathname }} />} */}

      <>
        <Routes>
          <Route
            path="/organization/:id/*"
            element={<OrganizationDashboardHome />}
          />

          <Route path="/" element={<JoinOrganizationPage />} />

          <Route element={<SetupLayout />}>
            <Route
              path="/create-organization"
              element={<CreateOrganizationPage />}
            />
            {/* <Route
              path="/edit-organization/:id"
              element={<EditOrganizationPage />}
            /> */}
            {/* <Route
              path="/claim-specific-organization/:id"
              element={<ClaimSpecificOrganizationPage />}
            /> */}
            <Route path="/claim-organization" element={<ClaimOrganizationPage />} />
            {/* <Route
              path="/search-organization/:query/:page"
              element={<SearchOrganizationPage />}
            /> */}

            <Route path="/join" element={<JoinOrganizationPage />} />
          </Route>
        </Routes>
      </>
    </>
  );
};

export default DashboardHome;
